export default __webpack_public_path__ + "static/media/image60.030a2f1b.svg";